import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    rules: {
      lessThanThreeMonths: 'The document must be less than 3 months old',
      mostRecent: 'The document must be the most recent',
      superiorToContribution:
        'The amount of your salary must be greater than or equal to the amount of the cash contribution',
      title: 'Make sure your document meets the following criteria:',
    },
    title: 'Add your',
    types: {
      bankStatement: 'bank or savings account statement',
      loanCertificate: 'certificate of loan from a financial institution',
      paySlip: 'pay slip',
    },
    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    uploadTitle: 'Drag and drop your document',
  },
  fr: {
    rules: {
      lessThanThreeMonths: 'Le document doit être daté de mois de 3 mois',
      mostRecent: 'Le document doit être le dernier en date',
      superiorToContribution:
        'Le montant de votre salaire doit être supérieur ou égal au montant de l’apport en numéraire',
      title: 'Assurez-vous que votre document respecte les critères suivants :',
    },
    title: 'Ajoutez votre',
    types: {
      bankStatement: 'relevé de compte bancaire ou épargne',
      loanCertificate: 'attestation de prêt d’un organisme financier',
      paySlip: 'bulletin de paie',
    },
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploadTitle: 'Déposez votre document ici',
  },
} as const);
